import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickVerdict = ({ verdict, confidence }) => {
  const getVerdictConfig = (type) => {
    const configs = {
      fair: {
        icon: 'CheckCircle2',
        color: 'text-success',
        bgColor: 'bg-success/10',
        borderColor: 'border-success/20',
        label: 'Fair Pricing'
      },
      aggressive: {
        icon: 'AlertTriangle',
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        borderColor: 'border-warning/20',
        label: 'Aggressive Pricing'
      },
      risky: {
        icon: 'AlertCircle',
        color: 'text-error',
        bgColor: 'bg-error/10',
        borderColor: 'border-error/20',
        label: 'High Risk'
      }
    };
    return configs?.[type] || configs?.fair;
  };

  const config = getVerdictConfig(verdict?.type);

  return (
    <div className={`w-full bg-card rounded-lg border ${config?.borderColor} p-4 md:p-6 lg:p-8 shadow-elevation-sm`}>
      <div className="flex items-start gap-4">
        <div className={`${config?.bgColor} p-3 md:p-4 rounded-lg flex-shrink-0`}>
          <Icon 
            name={config?.icon} 
            size={32} 
            color={`var(--color-${verdict?.type === 'fair' ? 'success' : verdict?.type === 'aggressive' ? 'warning' : 'error'})`}
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 mb-3">
            <h2 className={`text-xl md:text-2xl lg:text-3xl font-semibold ${config?.color}`}>
              {config?.label}
            </h2>
            <div className="flex items-center gap-2">
              <Icon name="TrendingUp" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground text-caption">
                Confidence: <span className="font-semibold text-data">{confidence}%</span>
              </span>
            </div>
          </div>

          <div className="prose prose-sm md:prose-base max-w-none">
            <p className="text-sm md:text-base text-foreground leading-relaxed font-body whitespace-pre-line">
              {verdict?.summary}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickVerdict;